export class IncomeCategory {
  constructor() {
    this.id = null;
    this.name = "";
    this.code = "";
    this.description = "";
    this.is_active = true;
  }
}
